import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link, withRouter } from 'react-router-dom';

import Header from '../components/Header';
import Footer from '../components/Footer';
import Loader from '../components/Loader';
import ThemeOverview from '../components/Pages/Themes/ThemeOverview';

import { fetchPosts } from '../requests/posts_request';

class Themes extends Component {
    componentDidMount() {
        document.title = `Themes - Friends for Brands`;
        window.scrollTo(0, 0);
    }
    componentWillMount() {
        this.getPosts(this.props, true);
    }

    getPosts(willMount = false) {
        if (willMount) {
            this.props.fetchPosts('theme');
        }
    }

    render() {
        return (
            <div className="page theme theme__overviewpage">
                <Header></Header>
                <div id="main-container">
                    <div className="content-container">
                        <div className="clearfix" />
                        <Link
                            to={{
                                pathname: '/behind-the-scenes',
                                state: { transition: 'slideLeft' },
                            }}
                            className="nav-btn">
                            <i className="icon icon-arrow_right" />
                            <span>Behind the scenes</span>
                        </Link>
                        {this.props.posts.fetched || this.props.posts.failed ? (
                            <ThemeOverview
                                posts={this.props.posts.posts}></ThemeOverview>
                        ) : (
                            <Loader
                                loaded={
                                    this.props.posts.fetched ||
                                    this.props.posts.failed
                                }
                            />
                        )}
                    </div>
                </div>
                <Footer></Footer>
            </div>
        );
    }
}

function mapStateToProps({ posts }) {
    return { posts };
}

export default withRouter(connect(mapStateToProps, { fetchPosts })(Themes));



// WEBPACK FOOTER //
// ./src/containers/Themes.jsx